/**
 * Shared between the root menu and a submenu, and between an item and a submenu trigger, so a nested
 * panel is indistinguishable from the one it opened out of.
 */
export const DROPDOWN_PANEL_CLASS = 'z-priority w-fit rounded-xl border border-subtle bg-surface-base shadow-dropdown outline-none'

export const DROPDOWN_PANEL_PADDING_CLASS = 'p-1.5'

// touch-manipulation: a row is tapped, never double-tapped, so opt it out of double-tap-to-zoom.
export const DROPDOWN_ITEM_CLASS =
    'flex h-8 touch-manipulation items-center gap-2 rounded-md px-2 py-1.5 text-default outline-none hover:cursor-pointer hover:bg-surface-muted focus:bg-surface-muted'

/**
 * A panel with a search field scrolls: the field holds still while the list moves under it. The height
 * cap is only a default — `className` on the panel overrides it.
 */
export const DROPDOWN_SEARCH_PANEL_CLASS = 'flex max-h-80 flex-col overflow-hidden'

export const DROPDOWN_SEARCH_ROW_CLASS = 'shrink-0 border-b border-subtle px-3.5 py-2.5'

export const DROPDOWN_SEARCH_INPUT_CLASS =
    'w-full bg-transparent font-hero-regular text-body leading-body tracking-body text-default outline-none placeholder:text-subtle'

/** The part of a searching panel that scrolls, which is everything below the field. */
export const DROPDOWN_SEARCH_LIST_CLASS = 'min-h-0 flex-1 overflow-y-auto'

/** The row a searching panel's Enter would choose, marked the way a focused row is. */
export const DROPDOWN_ITEM_ACTIVE_CLASS = 'bg-surface-muted'
